var cov_gzfihtog1 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Lazyload/styles/index.js",
      hash = "cc6a46d98cdded126584321dec822c811f4d2264",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Lazyload/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var lazyloadLess = {};
import genaration from '../../utils/classname';
export var lazyloadClass = (cov_gzfihtog1.s[0]++, genaration(lazyloadLess, 'lazyload'));